import { setPTYSize } from "./terminal";

const splitter = document.getElementById("splitter");
const chatPanel = document.getElementById("chat-panel");
const terminalPanel = document.getElementById("terminal-panel");

if (splitter && chatPanel && terminalPanel) {
  let isDragging = false;
  let startX = 0;
  let startWidth = 0;

  const minChatWidth = 280;
  const maxChatWidth = 900;

  const endDrag = () => {
    if (!isDragging) return;
    isDragging = false;

    document.body.classList.remove("cursor-col-resize");
    document.body.style.userSelect = "";
    splitter.classList.remove("bg-blue-700");
    splitter.classList.add("bg-gray-700");

    terminalPanel.style.pointerEvents = "";
    chatPanel.style.pointerEvents = "";

    setPTYSize();
  };

  splitter.addEventListener("mousedown", (e: MouseEvent) => {
    isDragging = true;
    startX = e.clientX;
    startWidth = chatPanel.offsetWidth;

    document.body.classList.add("cursor-col-resize");
    document.body.style.userSelect = "none";
    splitter.classList.add("bg-blue-700");
    splitter.classList.remove("bg-gray-700");

    terminalPanel.style.pointerEvents = "none";
    chatPanel.style.pointerEvents = "none";

    e.preventDefault();
  });

  window.addEventListener("mousemove", (e: MouseEvent) => {
    if (!isDragging) return;

    const delta = startX - e.clientX;
    let newWidth = startWidth + delta;

    newWidth = Math.max(minChatWidth, Math.min(maxChatWidth, newWidth));
    chatPanel.style.width = `${newWidth}px`;
    setPTYSize();
  });

  window.addEventListener("mouseup", endDrag);
  window.addEventListener("blur", endDrag);
} else {
  console.error("Splitter: required elements not found");
}
